/*
 * Roda do mouse na vertical rola o carrossel de itens na horizontal.
 *
 * O gesto natural sobre uma faixa horizontal é girar a roda, mas a roda produz
 * deltaY — que por padrão rola o drawer atrás. Aqui o deltaY é convertido em
 * scrollLeft do trilho.
 *
 * A regra que evita o efeito colateral clássico: o preventDefault só acontece
 * quando o trilho de fato andou. Nas pontas o evento passa adiante e o drawer
 * rola normalmente, em vez de o cursor ficar preso no carrossel.
 *
 * O listener fica no documento porque o cart-drawer.js substitui
 * <cart-drawer-items> inteiro a cada mudança do carrinho — ligar direto no
 * trilho perderia o vínculo na primeira atualização.
 */
(function () {
  'use strict';

  var TRILHO = '.cart-drawer tbody';

  document.addEventListener(
    'wheel',
    function (evento) {
      var trilho = evento.target.closest ? evento.target.closest(TRILHO) : null;
      if (!trilho) return;

      // Gesto horizontal (trackpad de lado) o navegador já resolve sozinho.
      if (Math.abs(evento.deltaX) > Math.abs(evento.deltaY)) return;

      // Firefox pode reportar o delta em linhas em vez de pixels.
      var passo = evento.deltaMode === 1 ? evento.deltaY * 16 : evento.deltaY;

      var antes = trilho.scrollLeft;
      trilho.scrollLeft += passo;

      // Andou? então o gesto era para o carrossel. Não andou (chegou na ponta)?
      // deixa passar, para o drawer rolar.
      if (trilho.scrollLeft !== antes) evento.preventDefault();
    },
    { passive: false },
  );
})();
